import { Injectable } from '@angular/core';
import { firstValueFrom, take } from 'rxjs';
import { EfCakeTopologyUiState } from 'src/app/shared/models/ef-cake-topology.model';
import { EfateSetupApiService } from 'src/app/shared/services/echo/efate-setup.api.service';
import { EfCakeTopologyStateUtils } from '../utils/ef-cake-topology-state.utils';

@Injectable({
  providedIn: 'root'
})
export class EfCakeTopologySharedService {
  constructor(private efateSetupApiService: EfateSetupApiService) {}

  async getCakeTopologyStateBySetupPk(efateSetupPk?: number): Promise<EfCakeTopologyUiState | undefined> {
    if (!efateSetupPk || efateSetupPk <= 0) {
      return undefined;
    }

    try {
      const topology = await firstValueFrom(this.efateSetupApiService.getEfateCakeTopologyBySetupPk(efateSetupPk).pipe(take(1)));
      const topologyJson = topology?.topologyJson ?? topology?.TopologyJson ?? topology;

      if (!topologyJson || typeof topologyJson !== 'string' || !topologyJson.trim()) {
        return undefined;
      }

      const parsed = JSON.parse(topologyJson) as Partial<EfCakeTopologyUiState>;
      return EfCakeTopologyStateUtils.buildUiState(parsed);
    } catch {
      return undefined;
    }
  }
}
